/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Swedish (Sweden): sv-se
 */

/**
 * Translation file for sv-SE locale
 *
 * @file sv.js
 * @author Mohamed yasar arabath M
 */

const sv = {
  'common.OK': 'Ok',
  'common.CONTINUE': 'Fortsätt',
  'browser.check.DONT_SHOW_AGAIN': 'Don\'t show me this again',
  'browser.check.SYS_REQUIREMENTS_LINK_TEXT': 'operativsystem och webbläsare som stöds',
  'browser.check.BROWSER_MESSAGE_TITLE': 'Din webbläsare <<name>> är föråldrad',
  'browser.check.BROWSER_MESSAGE_DESC': 'För att få den bästa upplevelsen väljer du en av de senaste webbläsarna:',
  'browser.check.BROWSER_SKIP_NOW': 'Hoppa över för tillfället',
  'browser.check.BROWSER_SUPPORTED_LINK_TEXT': 'Om webbläsare som stöds',
  'browser.check.BROWSER_UNSUPPORTED_TITLE': 'Din webbläsare, <<name>> stöds inte',
  'browser.check.BROWSER_UNSUPPORTED_DESC': 'För att få den bästa upplevelsen väljer du en av de webbläsarna som stöds.',
  'browser.check.OS_UNSUPPORTED_TITLE': 'Ditt operativsystem, <<name>> stöds inte',
  'browser.check.OS_UNSUPPORTED_DESC': 'While the product may work with no issues, please be aware that any problems you encounter might be resolved by trying with a device running a <<link>>',
  'errors.GENERIC_TITLE': 'Serverfel',
  'errors.GENERIC_DESC': 'Tyvärr ligger vårt system nere. Försök igen senare eller kontakta support.',
  'errors.HTTP_400_TITLE': 'Serverfel',
  'errors.HTTP_400_DESC': 'Vi stötte på ett fel vid behandling av din förfrågan.',
  'errors.HTTP_401_TITLE': 'Är du inloggad?',
  'errors.HTTP_401_DESC': 'Vi kunde inte hämta data eftersom din inloggningssession kan ha gått ut.',
  'errors.HTTP_403_TITLE': 'Inte autentiserade',
  'errors.HTTP_403_DESC': 'You don\'t have access to this resource.',
  'errors.HTTP_888_TITLE': 'Servern var för långsam för att svara',
  'errors.HTTP_888_DESC': 'Vi stötte på ett fel vid behandling av din förfrågan.'
};

export default sv;
